<template>
	<div>
		<loading v-if="!loaded" />
		<el-tabs v-model="tabName" v-if="loaded">
			<el-tab-pane label="All sensors" name="first"></el-tab-pane>
			<el-tab-pane label="Create new sensor" name="second"></el-tab-pane>
		</el-tabs>
		<div v-if="tabName == 'first' && loaded">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-40">
					<md-field>
						<label>Search sensor by ID</label>
						<md-input v-model="search.text" type="text" @keyup.enter="searchHandler()"></md-input>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-50 md-size-20">
					<md-field>
						<label>Status</label>
						<md-select placeholder="Status (All)" v-model="search.status">
							<md-option value="">All</md-option>
							<md-option value="1">Active</md-option>
							<md-option value="0">Inactive</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-small-size-50 md-size-20">
					<md-field>
						<label>Sensor Type</label>
						<md-select placeholder="Sensor Type (All)" v-model="search.sensor_type">
							<md-option value="">All</md-option>
							<md-option value="2">Water Level Sensor</md-option>
							<md-option value="5">Rain Gauge Sensor</md-option>
						</md-select>
					</md-field>
				</div>
				<div class="md-layout-item md-size-20">
					<md-button class="md-raised md-primary" @click="searchHandler()" style="width: 100%">Search
					</md-button>
				</div>
			</div>

			<md-table v-if="sensorList.length > 0">
				<md-table-row>
					<md-table-head>N<sup>o</sup></md-table-head>
					<md-table-head>Sensor & Station</md-table-head>
					<md-table-head>Current Value</md-table-head>
					<md-table-head>Type & Security Key</md-table-head>
					<md-table-head>Data Column</md-table-head>
					<md-table-head>Status</md-table-head>
					<md-table-head>Created Date</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>

				<md-table-row v-for="(sensor, index) in sensorList">
					<md-table-cell>{{ index + 1 }}, <b>{{ sensor.hash }}</b></md-table-cell>
					<md-table-cell><b>{{ sensor.name }}</b><br>{{ sensor.station_name }}</md-table-cell>
					<md-table-cell>
						<b>{{ sensor.value }}
							<span v-if="sensor.sensor_type_id == 2"> m.</span>
							<span v-if="sensor.sensor_type_id == 5"> mm.</span>
						</b>
						<br>({{config.timelify(sensor.value_updated_date)}})</md-table-cell>
					<md-table-cell><b>{{sensor.sensor_type_name}}</b><br>{{sensor.token}}</md-table-cell>
					<md-table-cell><b>{{sensor.value_column}}</b></md-table-cell>
					<md-table-cell>
						<span class="late" v-if="sensor.status == 0">{{config.getStatus(sensor.status)}}</span>
						<span class="green" v-if="sensor.status == 1">{{config.getStatus(sensor.status)}}</span>
					</md-table-cell>
					<md-table-cell><b>{{ config.datelify(sensor.created_date) }}</b><br>{{ config.timelify(sensor.created_date) }}</md-table-cell>
					<md-table-cell>
						<router-link :to="'/sensors/edit/' + sensor.hash">
							<md-button class="md-just-icon md-simple md-primary">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">Edit sensor information</md-tooltip>
							</md-button>
						</router-link>
						<md-button class="md-just-icon md-simple md-danger" @click="showDeleteAction(sensor.id)">
							<md-icon>close</md-icon>
							<md-tooltip md-direction="top">Delete this sensor</md-tooltip>
						</md-button>

					</md-table-cell>
				</md-table-row>
			</md-table>

			<h4 class="text-center" v-if="sensorList.length == 0 && loadMore == true">No sensor available</h4>
			<div class="places-buttons text-center" v-if="loadMore">
				<md-button class="md-primary" @click="searchHandler(true)">Show more</md-button>
			</div>
		</div>



		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Sensor Information</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* required</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Sensor Name *</label>
								<md-input type="text" v-model="sensor.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Sensor Type *</label>
								<md-select placeholder="Sensor Type *" v-model="sensor.sensor_type_id">
									<md-option v-for="sensor_type in sensorTypeList" :value="sensor_type.id" v-if="sensor_type.id > 1">{{sensor_type.name}}</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-50">
							<md-field>
								<label>Data Column *</label>
								<md-select placeholder="Data Column *" v-model="sensor.data_column">
									<md-option value="2">2</md-option>
									<md-option value="3">3</md-option>
									<md-option value="4">4</md-option>
									<md-option value="5">5</md-option>
									<md-option value="6">6</md-option>
									<md-option value="7">7</md-option>
								</md-select>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>Sensor Description *</label>
								<md-input type="text" v-model="sensor.description"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<label>Sensor Location *</label>
							<Map :latitude="12.734744" :longitude="104.177401" style="height: 300px"
								@locationUpdated="locationUpdated">
							</Map>
						</div>
						<!-- <div class="md-layout-item md-small-size-100 md-size-50">
							<label>Sensor Type *</label>
							<v-select label="name" inputId="id" :clearable="false" :options="referralList"
								v-model="client.referralArray">
							</v-select>
						</div> -->
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>Summary</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">Sensor Name</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(sensor.name).length > 0">{{sensor.name}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Sensor Type</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(sensor.sensor_type_id).length > 0">{{getSensorType}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Data Column</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(sensor.data_column).length > 0">{{sensor.data_column}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Sensor Latitude</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="sensor.lat != 0">{{sensor.lat}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>Sensor Longtiude</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="sensor.lng != 0">{{sensor.lng}}</span>
									<span v-else>N/A</span>
								</md-table-cell>
							</md-table-row>

						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="postSensor()">Create</md-button>
				</div>
			</div>

		</div>
		<md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this sensor ?"
			md-content="This sensor will be deleted and can't be recovered." md-confirm-text="Delete" md-cancel-text="Cancel"
			@md-cancel="clearAll" @md-confirm="onDelete" />
	</div>


	</div>

</template>

<script>
	import Map from 'vue-google-maps-location-selector';
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime, Map },
		created() {
			this.searchHandler();
			// this.getStation();
			this.getSettings();

			this.interval = setInterval(() => {
				this.searchHandler();
			}, 30000);
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					text: "",
					sensor_type: "",
					status: ""
				},
				interval: null,
				sensor: {
					name: "",
					lat: "",
					lng: "",
					data_column: "",
					sensor_type_id: "",
					description: ""
				},
				loadMore: true,
				sensorList: [],
				stationList: [],
				sensorTypeList: []
			}
		},
		watch: {
		},
		computed: {
			getSensorType() {
				let name = "";
				for(let i =0 ; i< this.sensorTypeList.length ;i++) {
					if(this.sensor.sensor_type_id == this.sensorTypeList[i].id) {
						return this.sensorTypeList[i].name;
					}
				}
				return "N/A"
			},
		},
		beforeDestroy() {
			clearInterval(this.interval);
		},
		methods: {
			locationUpdated(latLng) {
				this.sensor.lat = latLng.lat;
    			this.sensor.lng = latLng.lng;
			},
			postSensor() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/sensor/post", {
					sensor: this.sensor
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "Sensor was created successfully.",
							icon: 'done',
							type: 'success'
						});
						this.tabName = "first";
						this.searchHandler();
						this.clearAll();
					}
					// this.loadMoreCompanyButton = true

				})
			},
			// getStation() {
			// 	this.$http.post(this.config.api + "/admin/station/search", {
			// 		text: "",
			// 		status: 1,
			// 		offset: 0
			// 	}).then(data => {
			// 		this.stationList = data.body.data;
			// 		// this.referralList = data.body.data;
			// 	})
			// },
			getSettings() {
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.sensorTypeList = data.body.data.sensor_type;
					// this.referralList = data.body.data;
				})
			},
			searchHandler(more = false) {
				this.$http.post(this.config.api + "/admin/sensor/search", {
					text: this.search.text,
					status: this.search.status,
					sensor_type: this.search.sensor_type,
					offset: more ? this.sensorList.length : 0
				}).then(data => {
					this.loaded = true;
					this.search.text = "";
					if (data.body.data.length == 100) this.loadMore = true;
					else this.loadMore = false;
					this.sensorList = more ? this.sensorList.concat(data.body.data) : data.body.data;
					// this.sensorList = data.body.data;
				})
			},
			showDeleteAction(id) {
				this.deleteSelected = id
				this.deleteDialogActive = true
			},
			onDelete() {
				this.$http.post(this.config.api + "/admin/sensor/delete", {
					id: this.deleteSelected
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Sensor was deleted successfully.",
							icon: 'done',
							type: 'success'
						})
						// this.getEndLicense();
						this.searchHandler();
						this.clearAll();
					}
				})
			},
			checkValidation() {
				if (String(this.sensor.name).length > 0 &&
				String(this.sensor.sensor_type_id).length > 0 &&
				String(this.sensor.description).length > 0 &&
				String(this.sensor.lat).length > 0 &&
				String(this.sensor.lng).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "Please fill in information.",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.deleteDialogActive = false;
				this.deleteSelected = "";
				this.sensor = {
					name: "",
					lat: "",
					lng: "",
					sensor_type_id: "",
					description: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Sensors/View.vue